import { Tag } from 'antd';
import { TagCProps } from 'src/interface/Layout/Tag';

import classes from './index.module.css';
import cn from "src/utils/cn";

const TagC = (props: TagCProps) => {
	return (
		<Tag
			{...props}
			className={cn(
				props.type?.includes('chips') ? classes.chips : classes.tag,
				{
					[classes.primary]: props.type === 'primary-chips',
				},
				{
					[classes.active]: props.isactive,
				},
				props.className,
			)}
		>
			{props.children}

			{props.label && <Tag className={`${classes.label} ml-2`}>{props.labelText}</Tag>}
		</Tag>
	);
};

export default TagC;
